var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 155,
  height: 155,
  viewBox: "0 0 155 155",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 78,
  r: 78,
  fill: "#FFFFFF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10,78 L27,64 L27,92z",
  fill: "rgb(0 168 255)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowBg.161f6ae32b733fd62d7a9f931104fa48.svg";